export default __webpack_public_path__ + "static/media/gear-white.9f887544.svg";